import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-proportion",
  "use": "icon-proportion-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" preserveAspectRatio=\"xMidYMid meet\" fill=\"none\" role=\"presentation\" xmlns=\"http://www.w3.org/2000/svg\" class=\"\" id=\"icon-proportion\"><g><path data-follow-fill=\"currentColor\" d=\"M6.5 7a5 5 0 0 0 0 10h3a1 1 0 1 0 0-2h-3a3 3 0 0 1 0-6h3a1 1 0 0 0 0-2h-3Zm11 0a5 5 0 0 1 0 10h-3a1 1 0 1 1 0-2h3a3 3 0 0 0 0-6h-3a1 1 0 1 1 0-2h3ZM14 13a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2h4Z\" clip-rule=\"evenodd\" fill-rule=\"evenodd\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol